/**
 * @internal
 * **Do not use.** Ask about your use case in #hds-support.
 */

export const isOptionGroup = option => 'options' in option && !!option.options;

// This type does not include all of the methods and properties of the
// SelectCore class, it is a subset of the functions on the class that we use
// in utilities that is typed for type safety in those utilities